import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I developed a deep passion for DevOps and cloud technologies, and I’ve definitely picked up a few things along the way… 🤷‍♂️
              <br />
              <br />I’m well-versed in the essentials like
              <i>
                <b className="purple"> AWS, GCP, Azure, Kubernetes, and Terraform. </b>
              </i>
              <br />
              <br />
              My areas of Interest include building;
              <i>
                <b className="purple">scalable cloud infrastructure </b> and
                automating deployments, as well as exploring the cutting edge of{" "}
                <b className="purple">
                  containerization and orchestration.
                </b>
              </i>
              <br />
              <br />
              Whenever I can, I channel my enthusiasm into creating seamless CI/CD pipelines 
              with <b className="purple">Jenkins, Azure Devops</b> and
              <i>
                <b className="purple">
                  {" "}
                  optimizing cloud environments 
                </b>
              </i>
              &nbsp; to
              <i>
                <b className="purple"> deliver reliable, high-performance solutions.</b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/venkat-m-240b7a195/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
